import { Component, Input } from '@angular/core';
import { UIPlaceState } from 'src/app/_models/state/placeState';

@Component({
  selector: 'app-favorite-place-result',
  templateUrl: './favorite-place-result.component.html',
})
export class FavoritePlaceResultComponent {
  @Input() place: UIPlaceState[];
}
